



























import { defineComponent, PropType, ref, toRefs, computed, nextTick } from '@vue/composition-api';
import { SplitTestFormData, AdgroupFormData, CampaignFormData, CreateMode } from '@tt4b/ttam-enums';
import { useAdgroupBudgetValidate, useStdAccountStore } from '@tt4b/ttam-hooks';

import TtamSchedule from './../../adgroup/schedule/index';

const name = 'ttam-split-test-schedule';

export default defineComponent({
  name,
  components: {
    DaterangeTimepicker: TtamSchedule.TtamScheduleDaterangeTimepicker,
    Timezone: TtamSchedule.TtamScheduleTimezone,
  },
  props: {
    splitTestFormData: {
      type: Object as PropType<SplitTestFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    timezoneOffset: {
      type: Number,
      default: 0,
    },
    getAccountNowTimestamp: {
      type: Function,
      default: () => () => 0,
    },
  },
  setup(props, { emit }) {
    const scheduleRef = ref();
    const { timezone } = useStdAccountStore();

    const { adgroupData, campaignData, getAccountNowTimestamp } = toRefs(props);

    const { timeRangeValidator } = useAdgroupBudgetValidate({
      campaignFormData: campaignData,
      createMode: ref(CreateMode.CREATE),
      getAccountNowTimestamp,
    } as any);

    const _scheduleStartTime = computed({
      get: () => props.splitTestFormData.startTime,
      set: v => {
        emit('starttime-change', v);
      },
    });

    const _scheduleEndTime = computed({
      get: () => props.splitTestFormData.endTime,
      set: v => {
        emit('endtime-change', v);

        nextTick(() => {
          scheduleRef.value.validate && scheduleRef.value.validate('change');
        });
      },
    });

    return {
      name,
      timezone,
      scheduleRef,
      _scheduleStartTime,
      _scheduleEndTime,
      timeRangeValidator,
    };
  },
});
